import { Tab, TabList, TabPanel, Tabs } from '@carboncopyco/ui';
import type { TabProps } from '@carboncopyco/ui';
import type { ReactNode } from 'react';

export type CustomizeAssetTab = TabProps & {
  content: ReactNode;
};

export type CustomizeAssetLayoutProps = {
  tabs: CustomizeAssetTab[];
};

export const CustomizeAssetLayout = ({ tabs }: CustomizeAssetLayoutProps) => {
  return (
    <Tabs defaultTabId={tabs[0].id}>
      <div className="flex flex-col grow">
        <div className="pt-6 px-8 border-b">
          <TabList>
            {tabs.map((tab) => (
              <Tab
                key={tab.id}
                id={tab.id}
                label={tab.label}
              />
            ))}
          </TabList>
        </div>
        {tabs.map((tab) => {
          return (
            <TabPanel
              key={tab.id}
              tabId={tab.id}
            >
              {tab.content}
            </TabPanel>
          );
        })}
      </div>
    </Tabs>
  );
};
